import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ background }) => background};

  position: relative;
  /* .line-wand {
    position: absolute;
    left: 0;
    display: flex;
    justify-content: center;
    opacity: 0.5;
    .line {
      width: 270px;
      border: 0.5px solid #5a189a;
      height: 0;
      margin-top: 5px;
    }
    .circle {
      width: 10px;
      height: 10px;
      background: #5a189a;
      border-radius: 50%;
    }
  } */
  .ellipse {
    position: absolute;
    top: -100px;
    right: 25rem;
    z-index: 2;
    @media all and (max-width: 768px) {
      display: none;
    }
  }
  .wrapper {
    width: 100%;
    margin: 10rem 9rem;
    display: flex;
    flex-wrap: wrap-reverse;
    position: relative;
    justify-content: space-around;
    flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
    overflow: hidden;
    .text-content {
      margin-top: 6rem;
      span {
        margin-bottom: 12px;
        letter-spacing: 0.15em;
      }

      .header {
        font-size: 3.6rem;
        line-height: 4.5rem;
        max-width: 396px;
        margin: 12px 0;
      }

      .desc {
        font-size: 1.7rem;
        line-height: 2.8rem;
        max-width: 396px;
        margin: 8px 0;
      }

      .more-btn {
        background: transparent;
        margin: 2.4rem 0;
        font-size: 1.6rem;
        a {
        color: ${COLORS.primaryBackground};
          display: flex;
          align-items: center;
          text-decoration: none !important;
          font-weight: 400;
        }
        svg {
          margin: 0 8px;
          transition: 0.25s;
        }
        :hover {
          svg {
            width: 30px;
          }
        }
      }
    }
    .img-content {
      width: 450px;
      z-index: ${({ zIndex }) => zIndex};
      img {
        height: auto;
        width: 100%;
      }
      /* @media all and (max-width: 768px) {
        display: none;
      } */
    }
    @media all and (max-width: 1024px) {
      margin: 5rem 2rem;
    }
  }
`;
